import React from 'react'
import { AlertContentType } from './index'
import { StyledReminderAlert } from './style'
import IconButton from 'particles/Button/IconButton'
import RectangleButton, { RectangleLinkButton } from 'particles/Button/RectangleButton'
import Icon from 'particles/Icon'
import Text from 'particles/Text'

interface LinkProps {
    label: string
    to: string
}
interface ReminderAlertProps {
    form: AlertContentType
    title: string
    subtext?: string
    onClose?: () => void
    link?: LinkProps
    width?: string
    isClosable?: boolean
    action?: {
        callback: () => void
        label: string
    }
}

const ReminderAlert: React.FC<ReminderAlertProps> = ({
    form,
    title,
    subtext,
    onClose,
    width = '600px',
    link,
    isClosable,
    action,
}) => {
    return (
        <StyledReminderAlert form={form} width={width}>
            <Icon name="info" form="fill" color={form} size="20px" className="icon" />
            <div className="content-container">
                <div className="title-container">
                    <Text scale="bodyM700">{title}</Text>
                    {isClosable && onClose ? (
                        <IconButton
                            icon="x"
                            form="icon"
                            size="xs"
                            color="neutral"
                            onClick={onClose}
                            className="close-button"
                        />
                    ) : null}
                </div>
                <Text scale="bodyM400" color="secondary">
                    {subtext}
                </Text>
                {link?.to ? (
                    <RectangleLinkButton
                        form="text"
                        size="s"
                        color="primary"
                        label={link.label}
                        to={link.to}
                        className="link-button"
                    />
                ) : null}
                {action && (
                    <RectangleButton
                        form="text"
                        size="s"
                        color="primary"
                        onClick={action.callback}
                        className="link-button"
                        label={action.label}
                    />
                )}
            </div>
        </StyledReminderAlert>
    )
}

export default ReminderAlert
